import React from 'react';
import css from './EditListingBrandPremierPanel.module.css';
import EditListingLayoutSideNav from '../EditListingLayoutSideNav/EditListingLayoutSideNav';
import { H3 } from '../../../../components';
import classNames from 'classnames';
import { userSelector } from '../../../../ducks/user.duck';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { filterSubscriptionsByAuthor, isArrayLength } from '../../../../util/genericHelpers';
import { getUserSubscriptionLookupkeys, getUserType } from '../../../../util/userDataExtraction';
import EditListingBrandPremierForm from './EditListingBrandPremierForm/EditListingBrandPremierForm';
const EditListingBrandPremierPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
    config,
    subscriptionPrices,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const currentUser = useSelector(userSelector);
  const currentUserId = currentUser?.id?.uuid;
  const subscriptionMaybe =
    isArrayLength(subscriptionPrices) &&
    filterSubscriptionsByAuthor(subscriptionPrices, currentUserId);
  const lookupKeys = getUserSubscriptionLookupkeys(currentUser);
  const userType = getUserType(currentUser);
  return (
    <div className={classes}>
      <div className={css.contentLayoutWrapper}>
        <EditListingLayoutSideNav listing={listing} />
        <div className={css.detailContent}>
          <H3 as="h1">
            <FormattedMessage id="EditListingBrandPremierPanel.title" />
          </H3>

          <EditListingBrandPremierForm
            className={css.form}
            initialValues={{}}
            onSubmit={() => {}}
            updateInProgress={updateInProgress}
            saveActionMsg={submitButtonText}
            disabled={disabled}
            ready={ready}
            updated={panelUpdated}
            userType={userType}
            subscriptionMaybe={subscriptionMaybe}
            lookupKeys={lookupKeys}
          />
        </div>
      </div>
    </div>
  );
};

export default EditListingBrandPremierPanel;
